import clsx from "clsx";
import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import useTranslationFromJson from "../../hooks/useTranslationFromJSON";

import {
    AppBar,
    Container,
    Divider,
    Hidden,
    IconButton,
    Link,
    List,
    ListItem,
    Popover,
    Toolbar,
    Fab,
} from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { BlurCircular, BlurOn, ChevronLeft, ChevronRight, Menu } from "@material-ui/icons";

import LangSwitcher from "../../components/_common/LangSwitcher";

// import { menuItems } from "./menuItemsNoAPI";
import { commonMenuItems as menuItems } from "./DropdownMenu/commonMenu.config";

import DropdownMenu from "./DropdownMenu";

const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
    too: {
        color: "rgba(0,0,0,0.87)",
        padding: "0 10px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        fontSize: "1rem",
    },
    tooCurrent: {
        textDecoration: "none",
        position: "relative",
        overflow: "unset",
        "&:hover": {
            textDecoration: "none",
        },
        color: theme.palette.primary.main,
        fontWeight: 500,
        "&:after": {
            content: '" "',
            position: "absolute",
            width: "100%",
            height: 2,
            backgroundColor: theme.palette.primary.main,
            bottom: -16,
        },
    },
    noLink: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "none",
            cursor: "default",
        },
    },
    menuName: {
        display: "inline-flex",
        fontSize: "1rem",
    },
    menuNameDT: {
        display: "inline-block",
        whiteSpace: "normal",
        "@media (max-width: 1440px)": {
            fontSize: "0.875rem",
        },
        "@media (max-width: 1399px)": {
            fontSize: "0.75rem",
        },
        "@media (max-width: 1299px)": {
            fontSize: "0.7rem",
        },
        "@media (max-width: 1249px)": {
            fontSize: "0.675rem",
        },
    },
    menuNameCurrent: {
        textDecoration: "none",
        fontWeight: 500,
        color: theme.palette.primary.main,
    },
    menuIcon: {
        display: "inline-flex",
        alignItems: "center",
        marginTop: -4,
    },
    tooSub: {
        color: "#000000",
        padding: "0 24px",
        lineHeight: "48px",
        display: "block",
        alignItems: "center",
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        minHeight: 64,
        // justifyContent: "flex-end",
        justifyContent: "space-between",
    },
    topMenuWrapper: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "calc(100vw - 48px)",
         [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
         }
    },
    topMenuHolder: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
    },
    menuMobIcon: {},
    menuPopoverPaper: {
        width: "calc(100% - 16px)",
        maxWidth: 400,
        minHeight: "calc(100% - 16px)",
        left: "0!important",
        top: "0!important",
    },
    mobileMenuItemList: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        minHeight: "calc(100% - 66px)",
        position: "absolute",
        flexDirection: "column",
        justifyContent: "space-between",
        fontSize: "1.25rem",
    },
    mobileMenuItemSubList: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        flexDirection: "column",
        justifyContent: "space-between",
        marginLeft: 24,
        "& a": {
            fontSize: "0.8em",
        },
    },
    popover: {
        pointerEvents: "none",
        zIndex: "1667!important",
    },
    mobilePopper: {},
    paper: {
        backgroundColor: "#F8F9FA!important",
        boxShadow: `0px 4px 4px ${alpha(theme.palette.common.black, 0.2)}!important`,
        borderRadius: 0,
        padding: theme.spacing(0, 1),
        top: "52px!important",
    },
    subpaper: {
        backgroundColor: "#F8F9FA!important",
        boxShadow: `0px 4px 4px ${alpha(theme.palette.common.black, 0.2)}!important`,
        borderRadius: 0,
        padding: theme.spacing(0, 1),
    },
    cursorPointer: {
        cursor: "pointer",
    },
    toolbarRoot: {
        padding: 0,
    },
    toolbarRegular: {
        [theme.breakpoints.up("sm")]: {
            minHeight: 96,
        },
    },
    appBarSecondary: {
        position: "sticky",
        top: 0,
        padding: "27px 0 23px 0", //theme.spacing(4, 0),
        backgroundColor: theme.palette.common.white,
        boxShadow: "0px 2px 15px #0000000D",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0, 0),
        },
    },
    logoImg: {
        cursor: "pointer",
        marginLeft: 9,
        marginTop: 4,
        margin: theme.spacing(1, 0, 0, 2),
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(1, 2, 0, 0),
            maxWidth: 180,
        },
    },
}));

const MainHeader = ({ isMobile }) => {
    const classes = useStyles();
    const theme = useTheme();
    const { i18n, t } = useTranslation();
    const { translationFromJson } = useTranslationFromJson();
    const history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? "mobile-menu-popover" : undefined;

    const handleDrawerOpen = (event) => setAnchorEl(event.currentTarget);

    const handleDrawerClose = () => setAnchorEl(null);

    const handleGoto = (link) => {
        history.push(link);
        handleDrawerClose();
    };

    return (
        <>
            <AppBar position="fixed" color="transparent" elevation={0} className={classes.appBarSecondary} component={'div'}>
                <Container maxWidth={false} style={{ maxWidth: 1472, padding: 0 }}>
                    <Toolbar
                        variant={"dense"}
                        style={{ justifyContent: "space-between" }}
                        classes={{ root: classes.toolbarRoot, regular: classes.toolbarRegular }}
                    >
                        {isMobile ? (
                            <div className={classes.menuMobIcon}>
                                <IconButton
                                    aria-label="open menu"
                                    aria-describedby={id}
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    className={clsx(classes.menuButton)}
                                >
                                    <Menu />
                                </IconButton>
                            </div>
                        ) : (
                            <></>
                        )}

                        <div className={classes.topMenuWrapper}>
                            <a href={`/${i18n.language}`} id="global-main-logo" tabIndex={0}>
                                {isMobile ? (
                                    <img
                                        src={`/logos/logo-rsi-small.svg`}
                                        alt={t("Przejdź do strony głównej - GUS RSI - logo")}
                                        className={classes.logoImg}
                                    />
                                ) : (
                                    <img
                                        src={`/${i18n.language}/logos/logo-rsi-long.svg`}
                                        alt={t("Przejdź do strony głównej - GUS RSI - logo")}
                                        className={classes.logoImg}
                                    />
                                )}
                            </a>
                            <Hidden only={["xs"]}>
                                <div className={classes.topMenuHolder}>
                                    <DropdownMenu isMobile={isMobile} />
                                    <LangSwitcher style={{ marginRight: -20 }} />
                                </div>
                            </Hidden>
                        </div>
                    </Toolbar>
                </Container>
            </AppBar>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleDrawerClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                className={classes.mobilePopper}
                classes={{ paper: classes.menuPopoverPaper }}
            >
                <div className={classes.drawerHeader}>
                    {/* <LangSwitcher style={{}} /> */}
                    <Fab
                        color={"primary"}
                        size={"small"}
                        onClick={handleDrawerClose}
                        style={{
                            // boxShadow: "none",
                            width: 28,
                            height: 28,
                            minHeight: "unset",
                        }}
                    >
                        {theme.direction === "ltr" ? <ChevronLeft /> : <ChevronRight />}
                    </Fab>
                </div>
                <Divider
                    style={{
                        backgroundColor: "rgba(0,0,0,0.25)",
                        width: "90%",
                        margin: "0 auto",
                    }}
                />

                <List className={classes.mobileMenuItemList} component="nav">
                    <div>
                        {menuItems.map((m) => (
                            <React.Fragment key={m.id}>
                                <ListItem button>
                                    <Link
                                        style={{
                                            color: "inherit",
                                            fontSize: "1.25rem",
                                            textDecoration: "inherit",
                                            display: "flex",
                                        }}
                                        onClick={() => handleGoto(m.link)}
                                    >
                                        <span className={classes.menuIcon}>
                                            <BlurCircular
                                                style={{
                                                    marginRight: 8,
                                                    color: "rgba(0,0,0,0.33)",
                                                    fontSize: 16,
                                                }}
                                            />
                                        </span>
                                        <span className={classes.menuName}>
                                            {/* {t(`mainmenu.${m.title}`)} */}
                                            {translationFromJson(m, "name")}
                                        </span>
                                    </Link>
                                </ListItem>
                                {m.children && m.children.length && (
                                    <>
                                        <List
                                            className={classes.mobileMenuItemSubList}
                                            component={"div"}
                                            disablePadding
                                        >
                                            {m.children.map((child) => (
                                                <React.Fragment key={child.id}>
                                                    <ListItem button aria-current="page">
                                                        <Link
                                                            style={{
                                                                color: "inherit",
                                                                fontSize: "1.125rem",
                                                                textDecoration: "inherit",
                                                                display: "flex",
                                                            }}
                                                            onClick={() => handleGoto(child.link)}
                                                        >
                                                            <span className={classes.menuIcon}>
                                                                <BlurOn
                                                                    style={{
                                                                        marginRight: 8,
                                                                        color: "rgba(0,0,0,0.5)",
                                                                        fontSize: 15,
                                                                    }}
                                                                />
                                                            </span>
                                                            <span className={classes.menuName}>
                                                                {/* {t(`${child.title}`)} */}
                                                                {translationFromJson(child, "name")}
                                                            </span>
                                                        </Link>
                                                    </ListItem>
                                                    {!!child.children && !!child.children.length && (
                                                        <>
                                                            <List
                                                                className={classes.mobileMenuItemSubList}
                                                                component={"div"}
                                                                disablePadding
                                                            >
                                                                {child.children.map((kid) => (
                                                                    <React.Fragment key={kid.id}>
                                                                        <ListItem button>
                                                                            <Link
                                                                                style={{
                                                                                    color: "inherit",
                                                                                    fontSize: "1rem",
                                                                                    textDecoration: "inherit",
                                                                                    display: "flex",
                                                                                }}
                                                                                onClick={() => handleGoto(kid.link)}
                                                                            >
                                                                                <span className={classes.menuIcon}>
                                                                                    <BlurOn
                                                                                        style={{
                                                                                            marginRight: 8,
                                                                                            color: "rgba(0,0,0,0.5)",
                                                                                            fontSize: 13,
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                                <span className={classes.menuName}>
                                                                                    {/* {t(`${kid.title}`)} */}
                                                                                    {translationFromJson(kid, "name")}
                                                                                </span>
                                                                            </Link>
                                                                        </ListItem>
                                                                    </React.Fragment>
                                                                ))}
                                                            </List>
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </List>
                                    </>
                                )}
                                <Divider
                                    style={{
                                        backgroundColor: "rgba(0,0,0,0.05)",
                                        width: "90%",
                                        margin: "0 auto",
                                    }}
                                />
                            </React.Fragment>
                        ))}
                    </div>
                </List>
            </Popover>
        </>
    );
};

export default MainHeader;
